import { render, staticRenderFns } from "./ArticleListData.vue?vue&type=template&id=7b56ebd8&scoped=true&"
import script from "./ArticleListData.vue?vue&type=script&lang=js&"
export * from "./ArticleListData.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListData.vue?vue&type=style&index=0&id=7b56ebd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56ebd8",
  null
  
)

export default component.exports